import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M20.0563 0.943652L33.5563 0.94365C34.3847 0.943651 35.0563 1.61522 35.0563 2.44365L35.0563 15.9437C35.0563 16.7721 34.3847 17.4437 33.5563 17.4437C32.7279 17.4436 32.0563 16.7721 32.0563 15.9437L32.0563 6.06497L3.50425 34.617C2.91846 35.2028 1.96871 35.2028 1.38293 34.617C0.79714 34.0312 0.79714 33.0815 1.38293 32.4957L29.935 3.94365L20.0563 3.94365C19.2279 3.94365 18.5563 3.27208 18.5563 2.44365C18.5563 1.61522 19.2279 0.943651 20.0563 0.943652Z"
    }, null, -1)
  ]))]))
}
export default { render: render }